import { useState } from "react";
import { PasswordInput } from "@/components/common";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr("");
    if (!token) return setErr("Link non valido. Richiedi un nuovo reset.");
    if (pw.length < 8 || !/[a-zA-Z]/.test(pw) || !/[0-9]/.test(pw))
      return setErr("La password deve avere almeno 8 caratteri, con lettere e numeri.");
    if (pw !== confirm) return setErr("Le password non coincidono.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reimpostata. Ora puoi accedere.");
      nav("/login");
    } catch (e) { setErr(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-[#0F0F12] px-6" data-testid="reset-page">
      <div className="w-full max-w-[360px]">
        <div className="mb-8"><Logo height={28} /></div>
        <form onSubmit={submit}>
          <h2 className="font-display text-[1.7rem] font-bold tracking-tight mb-1.5">Nuova password</h2>
          <p className="text-sm text-slate-500 mb-7">Scegli una nuova password per il tuo account.</p>
          <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Nuova password</label>
          <PasswordInput testid="reset-new-pw" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password"
                 className="w-full mb-4 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 focus:border-[#FC82ED] focus:ring-2 focus:ring-[#FC82ED]/20 outline-none text-sm transition-all" placeholder="Almeno 8 caratteri, lettere e numeri" />
          <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Conferma password</label>
          <PasswordInput testid="reset-confirm-pw" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password"
                 className="w-full mb-5 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 focus:border-[#FC82ED] focus:ring-2 focus:ring-[#FC82ED]/20 outline-none text-sm transition-all" placeholder="••••••••" />
          {err && <div data-testid="reset-error" className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{err}</div>}
          <button data-testid="reset-submit" type="submit" disabled={loading}
                  className="w-full py-3 rounded-lg bg-[#FC82ED] hover:bg-[#e06dd2] text-black font-semibold text-sm transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 size={16} className="animate-spin" />} Salva nuova password
          </button>
          <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#111111]"><ArrowLeft size={15} /> Torna al login</Link>
        </form>
      </div>
    </div>
  );
}
